import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  SkeletonStdTableHead,
  SkeletonStdTableBody,
} from "../Skeleton Loading/SkeletonStdTable";
import { baseURL } from "../BaseUrl";
import { travelizeAuth } from "../HeaderAuthentication";
import Select from "react-select";
import moment from "moment";
import OnScrollLoading, { handleScroll } from "../OnScrollLoading";
import { loadManagerDropdown } from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { loggedInId } from "../LoginRole";
import { MiClearButton } from "../SbButtons/SbCancelBtn";

export default function CreatedForms(props) {
  let dispatch = useDispatch();

  const { managerDropdown } = useSelector((state) => state.data);

  const [isLoading, setIsLoading] = useState(true);
  const [searchVal, setSearchVal] = useState("");
  const [formNamesData, setFormNamesData] = useState([]);
  const [manager, setManager] = useState({
    value: loggedInId,
    label: "Select Manager",
  });

  const [loading, setLoading] = useState(false);

  // PAGINATION START
  const [PageSize, setPageSize] = useState(20);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [pageDataSize, setPageDataSize] = useState(0);
  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };
  const pageDataFrom = currentPage * PageSize - PageSize + 1;
  const pageDataTill = pageDataFrom + pageDataSize - 1;
  // PAGINATION END

  //* FETCH DROPDOWN DATA START *//
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(loadManagerDropdown());
  }, [manager]);
  //* FETCH DROPDOWN DATA END *//

  useEffect(() => {
    fetchCustomFormNames();
  }, [PageSize, currentPage, searchVal, manager]);

  const fetchCustomFormNames = () => {
    let requestOption = {
      method: "GET",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(
      `${baseURL}/api/CustomePages/Get?ManagerId=${manager.value}&PageSize=${PageSize}&CurrentPage=${currentPage}&Status=1&Text=${searchVal}`,
      requestOption
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          //   console.log("CUSFORMS-RES::", res.result);
          setFormNamesData(res.result);
          setTotalData(res.recordCount[0]);
          setIsLoading(false);
          setLoading(false);
        } else {
          console.log("CUS-FORM-RES::", `${res.message}`);
          setFormNamesData([]);
          setIsLoading(false);
          setLoading(false);
        }
      });
  };

  //* CLEAR SELECT START *//
  const clearSerachBySelect = () => {
    setManager({ value: loggedInId, label: "Select Manager" });
  };
  //* CLEAR SELECT END *//

  return (
    <div>
      <div id="main-page">
        <>
          {/* MAIN BODY START */}

          <div className="customforms-n-names-data">
            {/* Filter and Header Section */}
            <div className="pageHeader-bar">
              <div className="pageheader_bar_items">
                <div className="page-header-text-div">
                  <div className="back-btn" onClick={props.backToFormPage}>
                    <img
                      src="../../../../images/DefaultImages/back-btn-arrow.svg"
                      alt=""
                    />
                  </div>
                  <h6 className="page-header-text"> FORM NAMES </h6>
                </div>

                <div className="input-div">
                  <input
                    type="search"
                    id="metricInfo_search_bar"
                    placeholder="Search Form Name"
                    className="form-control setting-input"
                    // id="filterRowSearch"
                    value={searchVal}
                    onChange={(e) => setSearchVal(e.target.value)}
                  />
                  <i className="fa fa-search search-icon" />
                </div>
                <div className="dflex-j-end">
                  <div>
                    <Select
                      className="react-select-container-list"
                      classNamePrefix="react-select-list"
                      options={managerDropdown}
                      placeholder="Select Manager"
                      value={manager}
                      onInputChange={managerDropdown.label}
                      onChange={(data) => setManager(data)}
                      isSearchable={true}
                    />
                  </div>
                  {/* <div>
                    <Select
                      className="react-select-container-list"
                      classNamePrefix="react-select-list"
                      options={userDropdownByManager}
                      placeholder="Select User"
                      value={
                        filterUserId == "" ? "" : userDropdownByManager.value
                      }
                      onInputChange={userDropdownByManager.label}
                      onChange={(data) => setFilterUserId(data.value)}
                      isSearchable={true}
                    />
                  </div> */}
                  <MiClearButton
                    onClickEffect={clearSerachBySelect}
                    btnName="Clear"
                  />
                </div>
              </div>
            </div>

            {/* Filter and Header Section */}

            <div className="customforms-table">
              <div
                className="table-responsive routes-scrollbar"
                onScroll={(e) =>
                  handleScroll(
                    e,
                    formNamesData,
                    totalData,
                    setLoading,
                    setPageSize,
                    PageSize
                  )
                }
              >
                <table className="table routes-table-data">
                  <thead className="thead-light routes-thead">
                    {isLoading ? (
                      <>
                        <SkeletonStdTableHead />
                      </>
                    ) : (
                      <tr>
                        <th>SL.NO.</th>
                        <th>FORM NAME</th>
                        <th>CREATED BY</th>
                        <th>ADDED ON</th>
                        <th style={{ textAlign: "center" }}>DATA COUNT</th>
                        <th style={{ textAlign: "center" }}>ACTION</th>
                      </tr>
                    )}
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <>
                        <SkeletonStdTableBody />
                        <SkeletonStdTableBody />
                        <SkeletonStdTableBody />
                        <SkeletonStdTableBody />
                        <SkeletonStdTableBody />
                        <SkeletonStdTableBody />
                        <SkeletonStdTableBody />
                        <SkeletonStdTableBody />
                        <SkeletonStdTableBody />
                        <SkeletonStdTableBody />
                        <SkeletonStdTableBody />
                      </>
                    ) : formNamesData != "" ? (
                      formNamesData
                        .filter((item) => item.customePagesID != 1)
                        .map((data, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>
                              {" "}
                              <div className="table-row-head-Text">
                                {data?.pageName}
                              </div>
                            </td>
                            <td>{data?.addedByUserFullName}</td>
                            <td>
                              {moment(data?.addedOn, "DD/MM/YYYY").format(
                                "DD MMM YYYY"
                              )}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {data?.formCount}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {data?.formCount == 0 ? (
                                ""
                              ) : (
                                <div className="user-action-td">
                                  <span
                                    className="user-edit-link"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      props.openFormDataByuser();
                                      props.setCustomPageID(
                                        data?.customePagesID
                                      );
                                      props.setFormName(data?.pageName);
                                    }}
                                  >
                                    <i className="bi bi-eye-fill"></i> View
                                  </span>
                                </div>
                              )}
                            </td>
                          </tr>
                        ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-center">
                          {" "}
                          --- NO DATA FOUND ---{" "}
                        </td>
                      </tr>
                    )}
                    {loading && <OnScrollLoading />}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      </div>

      <></>
    </div>
  );
}
